import {useEffect, useState} from "react";
import {css, cx} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {Country} from "@pg-rp/common-types";

import {modalScroll} from "../../../../styles/receipes/pretty_scroll";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {getRecommendationFromProperty} from "../../../recommendations/utils/get_recommendation_from_property";
import {ViewType} from "../../../view_type/ViewType";
import {useApplicationMultiLeadPropertyList} from "../../hooks/multi_lead/use_application_multi_lead_property_list";
import {ApplicationMultiLeadResponsiveModalMap} from "./ApplicationMultiLeadResponsiveModalMap";
import {ApplicationMultiLeadResponsiveModalPropertyCard} from "./ApplicationMultiLeadResponsiveModalPropertyCard";

interface IProps {
    mainPropertyId?: IPropertyDetail["id"];
    allowToSelectMainProperty?: boolean;
    recommendedProperties: IRecommendedProperty[];
    selectedPropertyIds: number[];
    handleChange: (viewType: ViewType, propertyId: number) => void;
    handlePinClick: (viewType: ViewType | null, recommendedItemID: number) => void;
    originalApplicationGeoPoint: {coordinates: [number, number]} | null | undefined;
    originalApplicationCountry?: Country;
}

export const ApplicationMultiLeadResponsiveModalPropertyList = (props: IProps) => {
    const {mainPropertyId, recommendedProperties, selectedPropertyIds, handleChange, handlePinClick, originalApplicationGeoPoint, originalApplicationCountry} =
        props;
    const allowToSelectMainProperty = !!props.allowToSelectMainProperty;
    const {
        hoveredItemID,
        onListItemHover,
        listRef,
        listWrapRef,
        viewType,
        hasVerifiedPhone,
        mainPropertyDetail,
        isLoadingMainPropertyDetail,
        ignoredCn,
        sortedRecommendations
    } = useApplicationMultiLeadPropertyList({mainPropertyId, recommendedProperties});
    const [isListFadeVisible, setIsListFadeVisible] = useState(false);

    const updateListFade = () => {
        const list = listRef.current;

        setIsListFadeVisible(Boolean(list && list.scrollHeight - list.scrollTop - list.clientHeight > 1));
    };

    useEffect(() => {
        updateListFade();
    }, [isLoadingMainPropertyDetail, recommendedProperties.length]);

    if (isLoadingMainPropertyDetail) {
        return (
            <div className={loaderStyle}>
                <Loader size="md" />
            </div>
        );
    }

    return (
        <div className={rowStyle}>
            <div className={listColumnStyle}>
                <div ref={listRef} className={listScrollStyle} onScroll={updateListFade}>
                    <ul ref={listWrapRef} className={listStyle}>
                        <li className={cx(ignoredCn, trackingMarkerStyle)} aria-hidden="true" />
                        {allowToSelectMainProperty && mainPropertyDetail ? (
                            <ApplicationMultiLeadResponsiveModalPropertyCard
                                property={getRecommendationFromProperty(mainPropertyDetail)}
                                isViewedOffer
                                isSelected={selectedPropertyIds.includes(mainPropertyDetail.id)}
                                hidePrices={!hasVerifiedPhone}
                                onToggle={() => handleChange(ViewType.PROPERTY, mainPropertyDetail.id)}
                                onHover={onListItemHover}
                            />
                        ) : null}

                        {sortedRecommendations.map(({property, recommendationAdvantages}) => (
                            <ApplicationMultiLeadResponsiveModalPropertyCard
                                key={property.id}
                                property={property}
                                recommendationAdvantages={recommendationAdvantages}
                                isSelected={selectedPropertyIds.includes(property.id)}
                                hidePrices={!hasVerifiedPhone}
                                onToggle={() => handleChange(ViewType.PROPERTY, property.id)}
                                onHover={onListItemHover}
                            />
                        ))}
                    </ul>
                </div>

                {isListFadeVisible ? <div className={listFadeStyle} /> : null}
            </div>

            {originalApplicationGeoPoint && originalApplicationCountry ? (
                <div className={mapColumnStyle}>
                    <ApplicationMultiLeadResponsiveModalMap
                        checkedList={selectedPropertyIds}
                        viewType={viewType}
                        originalGeoPoint={originalApplicationGeoPoint}
                        originalCountry={originalApplicationCountry}
                        recommendations={recommendedProperties}
                        handlePinClick={handlePinClick}
                        hoveredItemID={hoveredItemID}
                        mainPropertyId={allowToSelectMainProperty ? mainPropertyId : undefined}
                    />
                </div>
            ) : null}
        </div>
    );
};

const loaderStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "24rem",
    md: {
        minHeight: "45.8rem"
    }
});

const rowStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    md: {
        flexDirection: "row",
        alignItems: "stretch",
        columnGap: 1,
        height: "45.8rem"
    }
});

const listColumnStyle = css({
    position: "relative",
    md: {
        flex: "0 0 39.7rem",
        height: "100%"
    }
});

const listScrollStyle = css({
    ...modalScroll,
    pl: "1.2rem",
    pr: "3.6rem",
    pb: 2,
    md: {
        height: "100%",
        overflowY: "auto",
        overscrollBehavior: "contain",
        scrollbarGutter: "stable",
        pl: 0,
        pr: 4
    }
});

const listStyle = css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    rowGap: 2,
    m: 0,
    p: 0,
    listStyle: "none"
});

const trackingMarkerStyle = css({
    position: "absolute",
    top: 0,
    left: 0,
    width: 0,
    height: 0
});

const listFadeStyle = css({
    display: "none",
    md: {
        position: "absolute",
        left: 0,
        right: "0.8rem",
        bottom: 0,
        display: "block",
        height: "4.6rem",
        background: "linear-gradient(0deg, var(--colors-white) 0%, rgba(255, 255, 255, 0) 100%)",
        pointerEvents: "none"
    }
});

const mapColumnStyle = css({
    md: {
        flex: "1 1 auto",
        minWidth: 0,
        height: "100%"
    }
});
import {useEffect, useState} from "react";
import {css, cx} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {Country} from "@pg-rp/common-types";

import {modalScroll} from "../../../../styles/receipes/pretty_scroll";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {getRecommendationFromProperty} from "../../../recommendations/utils/get_recommendation_from_property";
import {ViewType} from "../../../view_type/ViewType";
import {useApplicationMultiLeadPropertyList} from "../../hooks/multi_lead/use_application_multi_lead_property_list";
import {ApplicationMultiLeadResponsiveModalMap} from "./ApplicationMultiLeadResponsiveModalMap";
import {ApplicationMultiLeadResponsiveModalPropertyCard} from "./ApplicationMultiLeadResponsiveModalPropertyCard";

interface IProps {
    mainPropertyId?: IPropertyDetail["id"];
    allowToSelectMainProperty?: boolean;
    recommendedProperties: IRecommendedProperty[];
    selectedPropertyIds: number[];
    handleChange: (viewType: ViewType, propertyId: number) => void;
    handlePinClick: (viewType: ViewType | null, recommendedItemID: number) => void;
    originalApplicationGeoPoint: {coordinates: [number, number]} | null | undefined;
    originalApplicationCountry?: Country;
}

export const ApplicationMultiLeadResponsiveModalPropertyList = (props: IProps) => {
    const {mainPropertyId, recommendedProperties, selectedPropertyIds, handleChange, handlePinClick, originalApplicationGeoPoint, originalApplicationCountry} =
        props;
    const allowToSelectMainProperty = !!props.allowToSelectMainProperty;
    const {
        hoveredItemID,
        onListItemHover,
        listRef,
        listWrapRef,
        viewType,
        hasVerifiedPhone,
        mainPropertyDetail,
        isLoadingMainPropertyDetail,
        ignoredCn,
        sortedRecommendations
    } = useApplicationMultiLeadPropertyList({mainPropertyId, recommendedProperties});
    const [isListFadeVisible, setIsListFadeVisible] = useState(false);

    const updateListFade = () => {
        const list = listRef.current;

        setIsListFadeVisible(Boolean(list && list.scrollHeight - list.scrollTop - list.clientHeight > 1));
    };

    useEffect(() => {
        updateListFade();
    }, [isLoadingMainPropertyDetail, recommendedProperties.length]);

    if (isLoadingMainPropertyDetail) {
        return (
            <div className={loaderStyle}>
                <Loader size="md" />
            </div>
        );
    }

    return (
        <div className={rowStyle}>
            <div className={listColumnStyle}>
                <div ref={listRef} className={listScrollStyle} onScroll={updateListFade}>
                    <ul ref={listWrapRef} className={listStyle}>
                        <li className={cx(ignoredCn, trackingMarkerStyle)} aria-hidden="true" />
                        {allowToSelectMainProperty && mainPropertyDetail ? (
                            <ApplicationMultiLeadResponsiveModalPropertyCard
                                property={getRecommendationFromProperty(mainPropertyDetail)}
                                isViewedOffer
                                isSelected={selectedPropertyIds.includes(mainPropertyDetail.id)}
                                hidePrices={!hasVerifiedPhone}
                                onToggle={() => handleChange(ViewType.PROPERTY, mainPropertyDetail.id)}
                                onHover={onListItemHover}
                            />
                        ) : null}

                        {sortedRecommendations.map(({property, recommendationAdvantages}) => (
                            <ApplicationMultiLeadResponsiveModalPropertyCard
                                key={property.id}
                                property={property}
                                recommendationAdvantages={recommendationAdvantages}
                                isSelected={selectedPropertyIds.includes(property.id)}
                                hidePrices={!hasVerifiedPhone}
                                onToggle={() => handleChange(ViewType.PROPERTY, property.id)}
                                onHover={onListItemHover}
                            />
                        ))}
                    </ul>
                </div>

                {isListFadeVisible ? <div className={listFadeStyle} /> : null}
            </div>

            {originalApplicationGeoPoint && originalApplicationCountry ? (
                <div className={mapColumnStyle}>
                    <ApplicationMultiLeadResponsiveModalMap
                        checkedList={selectedPropertyIds}
                        viewType={viewType}
                        originalGeoPoint={originalApplicationGeoPoint}
                        originalCountry={originalApplicationCountry}
                        recommendations={recommendedProperties}
                        handlePinClick={handlePinClick}
                        hoveredItemID={hoveredItemID}
                        mainPropertyId={allowToSelectMainProperty ? mainPropertyId : undefined}
                    />
                </div>
            ) : null}
        </div>
    );
};

const loaderStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "24rem",
    md: {
        minHeight: "45.8rem"
    }
});

const rowStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    md: {
        flexDirection: "row",
        alignItems: "stretch",
        columnGap: 1,
        height: "45.8rem"
    }
});

const listColumnStyle = css({
    position: "relative",
    md: {
        flex: "0 0 39.7rem",
        height: "100%"
    }
});

const listScrollStyle = css({
    ...modalScroll,
    pl: "1.2rem",
    pr: "3.6rem",
    pb: 2,
    md: {
        height: "100%",
        overflowY: "auto",
        overscrollBehavior: "contain",
        scrollbarGutter: "stable",
        pl: 0,
        pr: 4
    }
});

const listStyle = css({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    rowGap: 2,
    m: 0,
    p: 0,
    listStyle: "none"
});

const trackingMarkerStyle = css({
    position: "absolute",
    top: 0,
    left: 0,
    width: 0,
    height: 0
});

const listFadeStyle = css({
    display: "none",
    md: {
        position: "absolute",
        left: 0,
        right: "0.8rem",
        bottom: 0,
        display: "block",
        height: "4.6rem",
        background: "linear-gradient(0deg, var(--colors-white) 0%, rgba(255, 255, 255, 0) 100%)",
        pointerEvents: "none"
    }
});

const mapColumnStyle = css({
    md: {
        flex: "1 1 auto",
        minWidth: 0,
        height: "100%"
    }
});
